import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["clearButtonText", "dataTestId", "isDisabled", "isReadOnly", "onClick"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import { NormalizedButton } from "../../button";
import { getRem, transitionAnimation, visuallyHidden } from "../../core";
import { IconCancelOutlined } from "../../icons";
import { KEY_CODES } from "../../utilities";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var BUTTON_ICON_SIZE = getRem('24px');
var StyledClearButton = styled(NormalizedButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  align-items: center;\n  border-radius: ", ";\n  cursor: pointer;\n  display: flex;\n  fill: ", ";\n  height: ", ";\n  justify-content: center;\n  padding: 0;\n  width: ", ";\n  ", "\n"])), transitionAnimation('background-color, fill'), function (_ref) {
  var theme = _ref.theme;
  return theme.size.borderRadius.full.value;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.text.light.secondary.value;
}, BUTTON_ICON_SIZE, BUTTON_ICON_SIZE, function (_ref3) {
  var isDisabled = _ref3.isDisabled,
      isReadOnly = _ref3.isReadOnly,
      theme = _ref3.theme;
  return !isDisabled && !isReadOnly && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      &:hover,\n      &:focus {\n        background-color: ", ";\n        fill: ", ";\n      }\n    "])), theme.color.text.light.secondary.value, theme.color.additional.light.value);
});
var StyledClearButtonIcon = styled(IconCancelOutlined)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n"])), BUTTON_ICON_SIZE, BUTTON_ICON_SIZE);
var StyledClearButtonText = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  ", ";\n\n  && {\n    position: absolute;\n  }\n"])), visuallyHidden);

var InputClearIcon = function InputClearIcon(_ref4) {
  var clearButtonText = _ref4.clearButtonText,
      dataTestId = _ref4.dataTestId,
      isDisabled = _ref4.isDisabled,
      isReadOnly = _ref4.isReadOnly,
      onClick = _ref4.onClick,
      other = _objectWithoutProperties(_ref4, _excluded);

  var handleKeyDown = function handleKeyDown(event) {
    var keyCode = event.keyCode || event.which || 0;

    if (keyCode === KEY_CODES.SPACE) {
      event.target.click();
    }
  };

  return /*#__PURE__*/_jsxs(StyledClearButton, _objectSpread(_objectSpread({
    "data-testid": dataTestId ? "".concat(dataTestId, "-clear-icon") : undefined,
    isDisabled: isDisabled,
    isReadOnly: isReadOnly,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    type: "button"
  }, other), {}, {
    children: [/*#__PURE__*/_jsx(StyledClearButtonText, {
      children: clearButtonText
    }), /*#__PURE__*/_jsx(StyledClearButtonIcon, {})]
  }));
};

InputClearIcon.displayName = "InputClearIcon";
InputClearIcon.propTypes = {
  /** Label for clear icon button */
  clearButtonText: PropTypes.string.isRequired,

  /** Id value used for testing */
  dataTestId: PropTypes.string,

  /** If true, adjusts label styling */
  isDisabled: PropTypes.bool,

  /** If true, adjusts label styling */
  isReadOnly: PropTypes.bool,

  /** Callback to be called when  clear button is clicked */
  onClick: PropTypes.func.isRequired
};
InputClearIcon.defaultProps = {
  dataTestId: undefined,
  isDisabled: false,
  isReadOnly: false
};
export { InputClearIcon };